import { render } from "./OptionsInput.vue?vue&type=template&id=6e77aeaa&scoped=true"
import script from "./OptionsInput.vue?vue&type=script&lang=js"
export * from "./OptionsInput.vue?vue&type=script&lang=js"

import "./OptionsInput.vue?vue&type=style&index=0&id=6e77aeaa&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e77aeaa"]])

export default __exports__